<template>
      <!--selection -panel-->
      <div
        
          class="absolute inset-x-0 top-14 left-3 z-50 transform w-[290px]" >
          <!-- sidebar-pop-up -->
          
          <div class="bg-white p-5 shadow-lg rounded-lg">
  <a
  @click.prevent="selectMenu('billing')"
   
    href="#"
    class="flex items-center hover:bg-gray-50 px-2 py-2 w-[250px] rounded-md">
    <div
      class="w-9 h-9 flex items-center justify-center bg-[#F7F7FF] rounded-md mr-3 my-1.5">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4745_21038"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4745_21038)">
          <path
            d="M10 17.5C8.95833 17.5 7.98278 17.3022 7.07333 16.9067C6.16333 16.5106 5.37167 15.9756 4.69833 15.3017C4.02444 14.6283 3.48944 13.8367 3.09333 12.9267C2.69778 12.0172 2.5 11.0417 2.5 10C2.5 8.95833 2.69778 7.9825 3.09333 7.0725C3.48944 6.16306 4.02444 5.37139 4.69833 4.6975C5.37167 4.02417 6.16333 3.48944 7.07333 3.09333C7.98278 2.69778 8.95833 2.5 10 2.5C11.1389 2.5 12.2189 2.74306 13.24 3.22917C14.2606 3.71528 15.125 4.40278 15.8333 5.29167V3.33333H17.5V8.33333H12.5V6.66667H14.7917C14.2222 5.88889 13.5208 5.27778 12.6875 4.83333C11.8542 4.38889 10.9583 4.16667 10 4.16667C8.375 4.16667 6.99667 4.7325 5.865 5.86417C4.73278 6.99639 4.16667 8.375 4.16667 10C4.16667 11.625 4.73278 13.0033 5.865 14.135C6.99667 15.2672 8.375 15.8333 10 15.8333C11.4583 15.8333 12.7325 15.3611 13.8225 14.4167C14.9131 13.4722 15.5556 12.2778 15.75 10.8333H17.4583C17.25 12.7361 16.4342 14.3228 15.0108 15.5933C13.5869 16.8644 11.9167 17.5 10 17.5ZM12.3333 13.5L9.16667 10.3333V5.83333H10.8333V9.66667L13.5 12.3333L12.3333 13.5Z"
            fill="#64648C" />
        </g>
      </svg>
    </div>
    <div>
      <p class="text-sm text-gray-900 ">Billing</p>
      <p class="text-xs text-[#64648C]">Subsciption Management</p>
    </div>
  </a>
  <!-- end of button -->
  <!-- Chargebee Payment -->
  <a
  @click.prevent="selectMenu('payments')"
    href="#"
    class="flex items-center hover:bg-gray-50 px-2 py-2 w-[250px] rounded-md my-1.5">
    <div
      class="w-9 h-9 flex items-center justify-center bg-[#F7F7FF] rounded-md mr-3">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4745_21046"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4745_21046)">
          <path
            d="M18.3332 5.00016V15.0002C18.3332 15.4585 18.1701 15.851 17.844 16.1777C17.5173 16.5038 17.1248 16.6668 16.6665 16.6668H3.33317C2.87484 16.6668 2.48262 16.5038 2.1565 16.1777C1.82984 15.851 1.6665 15.4585 1.6665 15.0002V5.00016C1.6665 4.54183 1.82984 4.14961 2.1565 3.8235C2.48262 3.49683 2.87484 3.3335 3.33317 3.3335H16.6665C17.1248 3.3335 17.5173 3.49683 17.844 3.8235C18.1701 4.14961 18.3332 4.54183 18.3332 5.00016ZM3.33317 6.66683H16.6665V5.00016H3.33317V6.66683ZM3.33317 10.0002V15.0002H16.6665V10.0002H3.33317Z"
            fill="#64648C" />
        </g>
      </svg>
    </div>
    <div>
      <p class="text-sm text-gray-900 ">Chargebee Payments</p>
      <p class="text-xs text-[#64648C]">Payment Solution</p>
    </div>
  </a>
  <!-- end of button -->
  <!-- Retention -->
  <a
    href="https://www.chargebee.com/retention/"
    class="flex items-center hover:bg-gray-50 px-2 py-2 w-[250px] rounded-md my-1.5"
    target="_blank">
    <div
      class="w-9 h-9 flex items-center justify-center bg-[#F7F7FF] rounded-md mr-3">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4748_24329"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4748_24329)">
          <path
            d="M9.99984 14.5832C10.9443 14.5832 11.8021 14.3159 12.5732 13.7815C13.3437 13.2465 13.9026 12.5415 14.2498 11.6665H5.74984C6.09706 12.5415 6.65623 13.2465 7.42734 13.7815C8.19789 14.3159 9.05539 14.5832 9.99984 14.5832ZM6.49984 9.1665L7.4165 8.2915L8.2915 9.1665L9.1665 8.2915L7.4165 6.49984L5.62484 8.2915L6.49984 9.1665ZM11.7082 9.1665L12.5832 8.2915L13.4998 9.1665L14.3748 8.2915L12.5832 6.49984L10.8332 8.2915L11.7082 9.1665ZM9.99984 18.3332C8.84706 18.3332 7.76373 18.1143 6.74984 17.6765C5.73595 17.2393 4.854 16.6457 4.104 15.8957C3.354 15.1457 2.76039 14.2637 2.32317 13.2498C1.88539 12.2359 1.6665 11.1526 1.6665 9.99984C1.6665 8.84706 1.88539 7.76373 2.32317 6.74984C2.76039 5.73595 3.354 4.854 4.104 4.104C4.854 3.354 5.73595 2.76011 6.74984 2.32234C7.76373 1.88511 8.84706 1.6665 9.99984 1.6665C11.1526 1.6665 12.2359 1.88511 13.2498 2.32234C14.2637 2.76011 15.1457 3.354 15.8957 4.104C16.6457 4.854 17.2393 5.73595 17.6765 6.74984C18.1143 7.76373 18.3332 8.84706 18.3332 9.99984C18.3332 11.1526 18.1143 12.2359 17.6765 13.2498C17.2393 14.2637 16.6457 15.1457 15.8957 15.8957C15.1457 16.6457 14.2637 17.2393 13.2498 17.6765C12.2359 18.1143 11.1526 18.3332 9.99984 18.3332ZM9.99984 16.6665C11.8609 16.6665 13.4373 16.0207 14.729 14.729C16.0207 13.4373 16.6665 11.8609 16.6665 9.99984C16.6665 8.13873 16.0207 6.56234 14.729 5.27067C13.4373 3.979 11.8609 3.33317 9.99984 3.33317C8.13873 3.33317 6.56234 3.979 5.27067 5.27067C3.979 6.56234 3.33317 8.13873 3.33317 9.99984C3.33317 11.8609 3.979 13.4373 5.27067 14.729C6.56234 16.0207 8.13873 16.6665 9.99984 16.6665Z"
            fill="#64648C" />
        </g>
      </svg>
    </div>
    <div>
      <p class="text-sm text-gray-900 ">Retention</p>
      <p class="text-xs text-[#64648C]">Customer Retention</p>
    </div>
  </a>
  <!-- end of button -->
  <!-- RevRec -->
  <a href="https://www.chargebee.com/revenue-recognition-software/"
    class="flex items-center hover:bg-gray-50 px-2 py-2 w-[250px] rounded-md my-1.5" target="_blank">
    <div
      class="w-9 h-9 flex items-center justify-center bg-[#F7F7FF] rounded-md mr-3">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4748_24337"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4748_24337)">
          <path
            d="M11.6668 10.8335C10.9724 10.8335 10.3821 10.5904 9.896 10.1043C9.40989 9.61822 9.16683 9.02794 9.16683 8.3335C9.16683 7.63905 9.40989 7.04877 9.896 6.56266C10.3821 6.07655 10.9724 5.8335 11.6668 5.8335C12.3613 5.8335 12.9516 6.07655 13.4377 6.56266C13.9238 7.04877 14.1668 7.63905 14.1668 8.3335C14.1668 9.02794 13.9238 9.61822 13.4377 10.1043C12.9516 10.5904 12.3613 10.8335 11.6668 10.8335ZM5.8335 13.3335C5.37516 13.3335 4.98294 13.1702 4.65683 12.8435C4.33016 12.5174 4.16683 12.1252 4.16683 11.6668V5.00016C4.16683 4.54183 4.33016 4.14961 4.65683 3.8235C4.98294 3.49683 5.37516 3.3335 5.8335 3.3335H17.5002C17.9585 3.3335 18.351 3.49683 18.6777 3.8235C19.0038 4.14961 19.1668 4.54183 19.1668 5.00016V11.6668C19.1668 12.1252 19.0038 12.5174 18.6777 12.8435C18.351 13.1702 17.9585 13.3335 17.5002 13.3335H5.8335ZM7.50016 11.6668H15.8335C15.8335 11.2085 15.9966 10.816 16.3227 10.4893C16.6493 10.1632 17.0418 10.0002 17.5002 10.0002V6.66683C17.0418 6.66683 16.6493 6.5035 16.3227 6.17683C15.9966 5.85072 15.8335 5.4585 15.8335 5.00016H7.50016C7.50016 5.4585 7.33683 5.85072 7.01016 6.17683C6.68405 6.5035 6.29183 6.66683 5.8335 6.66683V10.0002C6.29183 10.0002 6.68405 10.1632 7.01016 10.4893C7.33683 10.816 7.50016 11.2085 7.50016 11.6668ZM16.6668 16.6668H2.50016C2.04183 16.6668 1.64961 16.5038 1.3235 16.1777C0.996829 15.851 0.833496 15.4585 0.833496 15.0002V5.8335H2.50016V15.0002H16.6668V16.6668Z"
            fill="#64648C" />
        </g>
      </svg>
    </div>
    <div>
      <p class="text-sm text-gray-900 ">RevRec</p>
      <p class="text-xs text-[#64648C]">Revenue Recognition</p>
    </div>
  </a>
  <!-- end of button -->
  <!-- Receivables -->
  <a href="https://www.chargebee.com/receivables/"
    class="flex items-center hover:bg-gray-50 px-2 py-2 w-[250px] rounded-md my-1.5" target="_blank">
    <div
      class="w-9 h-9 flex items-center justify-center bg-[#F7F7FF] rounded-md mr-3">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4748_24345"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4748_24345)">
          <path
            d="M4.1665 15.8335V7.50016H5.83317V13.0002L15.4998 3.3335L16.6665 4.50016L6.99984 14.1668H12.4998V15.8335H4.1665Z"
            fill="#64648C" />
        </g>
      </svg>
    </div>
    <div>
      <p class="text-sm text-gray-900 ">Receivables</p>
      <p class="text-xs text-[#64648C]">Receivables Management</p>
    </div>
  </a>
  <!-- end of button -->
</div>
          <!--sidebar-pop ends-->

        </div>

                <!--show dashboard div ends-->
</template>

<script>
export default {
    name: 'ProductSwitcher',
    props: {
      menuTitle: String,
      products: Array
    },
    data(){
      return {
       dropMenuTitle: null,
      
      }
    },
    methods:{
      selectMenu(title){ 
        
        this.$emit('selectedMenu', title);
        this.closeSwitcher()
      },
      selectMenus(title){
            this.dropMenuTitle = title;
            if(this.dropMenuTitle == 'Billing') {
                this.changeToCB();
                this.img = 'billing.svg'
            }else if(this.dropMenuTitle == 'Analytics'){
                this.img = 'revrec.svg'
            }
            
            else if(this.dropMenuTitle == 'Retention') {
                this.changeToRevlock()
                this.img = 'billing.svg'
            } else if(this.dropMenuTitle == 'RevRec') {
                this.chnageToBrightback() 
                this.img = 'revrec.svg'
            }
            else if(this.dropMenuTitle == 'Marketplace') {
                this.chnageToBrightback() 
                this.img = 'billing.svg'
            }
            else if(this.dropMenuTitle == 'Receivables') {
                this.chnageToBrightback() 
                this.img = 'revrec.svg'
            }

            this.menuDropdown = false;
        },

        closeSwitcher() {
          this.$emit('closeSwitcher')
        }

    },
    created(){
     // console.log('switcher ', this.products)
    }
}
</script>